/// <amd-module name="Environments/EnvironmentDetails/Common/Utils" />
import { EnvironmentInstance, EnvironmentResourceReference, EnvironmentResourceType } from "DistributedTask/Client/Contracts/TaskAgent";
import { IEnvironmentObject, IEnvironmentResourceObject } from "Environments/Client/EnvironmentContracts";

import { IVssPageContext } from "VSS/Platform/Context";
import { getAssetLocation } from "VSS/Platform/Location";
import * as Resources from "Environments/EnvironmentDetails/Resources";

export class PageKey {
    public static EnvironmentView = "environment";
    public static EnvironmentDeploymentHistory = "env-dep-history";
}

export function getErrorMessage(error: any): string{
    let errorMessage: string = error ? error.message || error : "";
    return errorMessage;
}

export namespace PerformanceScenarios {
    export const EnvironmentResourcesPageLoad: string = "Pipelines.Environment.Resources";
    export const EnvironmentDeploymentsPageLoad: string = "Pipelines.Environment.Deployments";
}

export namespace FilterKeys {
    export const ResourceNameFilterKey: string = "ResourceNameFilter";
    export const DeploymentStatusFilterKey: string = "DeploymentStatusFilter";
    export const ResourceTypeFilterKey: string = "ResourceTypeFilter";
}

export function convertIEnvironmentObjectFromEnvironmentInstance(environmentInstance: EnvironmentInstance): IEnvironmentObject{
    return  {
        createdBy: environmentInstance.createdBy,
        createdOn: environmentInstance.createdOn,
        description: environmentInstance.description,
        id: environmentInstance.id,
        lastModifiedBy: environmentInstance.lastModifiedBy,
        lastModifiedOn: environmentInstance.lastModifiedOn,
        name: environmentInstance.name,
        resources: convertIEnvironmentResourceObjectsFromEnvironmentResources(environmentInstance.resources),
        deploymentRecords: [],
        project: environmentInstance.project
    } as IEnvironmentObject;
}

export function convertIEnvironmentResourceObjectsFromEnvironmentResources(environmentResourceReferences: EnvironmentResourceReference[]): IEnvironmentResourceObject[] {
    let environmentResourceObjects:  IEnvironmentResourceObject[] = [];
    if(!environmentResourceReferences){
        return [];
    } else {
        environmentResourceReferences.forEach((environmentResourceReference: EnvironmentResourceReference) =>{
            environmentResourceObjects.push({
                id: environmentResourceReference.id,
                name: environmentResourceReference.name,
                type: environmentResourceReference.type,
                deploymentRecords: [],
                tags: []
            } as IEnvironmentResourceObject);
        });
    }

    return environmentResourceObjects;
}

export function getResourceIconUrl(pageContext: IVssPageContext, type: EnvironmentResourceType): string {
    switch (type) {
        case EnvironmentResourceType.Kubernetes:
            return getAssetLocation(pageContext, "ms.vss-environments-web/environment-details/Images/kubernetes.svg");
        case EnvironmentResourceType.VirtualMachine:
            return getAssetLocation(pageContext, "ms.vss-environments-web/environment-details/Images/virtualmachine.svg");
        default:
            return "";
    }
}

export function getResourceName(type: EnvironmentResourceType): string {
    switch (type) {
        case EnvironmentResourceType.Kubernetes:
            return Resources.KubernetesResource;
        case EnvironmentResourceType.VirtualMachine:
            return Resources.VirtualMachineResource;
        default:
            return Resources.NoneResource;
    }
}


export const Area = "EnvironmentDeployment";

export namespace FeatureNames {
    export const EnvironmentView = "EnvironmentView";
    export const EnvironmentResourcesView = "EnvironmentResourcesView";
}

export namespace Action {
    export const ResourcePageJobNavigation = "ResourcePageJobNavigation";
    export const EnvironmentEdited = "EnvironmentEdited";
    export const EnvironmentDeleted = "EnvironmentDeleted";
    export const EnvironmentResourceDeleted = "EnvironmentResourceDeleted";
    export const ResourceTabNavigation = "ResourceTabNavigation";
    export const DeploymentTabNavigation = "DeploymentTabNavigation";
    export const FilterApplied = "FilterApplied";
}

export namespace EnvironmentTabIds {
    export const ResourcesTabId = "resources";
    export const DeploymentsTabId = "deployments";
}